import React from "react";
import { Navigation } from "../components/Navigation";

interface SuccessSectionProps {
  onContinue: () => void;
  onPrevious: () => void;
}

export const SuccessSection: React.FC<SuccessSectionProps> = ({
  onContinue,
  onPrevious,
}) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-warmWhite dark:bg-darkBg transition-colors duration-400">
      <div className="max-w-lg text-center space-y-8 animate-fade-in">
        <div className="text-6xl animate-bounce-gentle">❤️</div>
        <div className="space-y-4">
          <p className="text-2xl md:text-3xl font-semibold text-deepCharcoal dark:text-darkText">
            This space is just for you
          </p>
          <p className="text-lg text-mutedGray dark:text-gray-400">
            Created with love, <br /> for everything we share and everything
            ahead.
          </p>
        </div>
        <Navigation
          onNext={onContinue}
          onPrevious={onPrevious}
          nextLabel="Continue"
          showPrevious={true}
        />
      </div>
    </div>
  );
};
